import React, { memo } from "react";
import { Rows2 } from "lucide-react";
import Select from "react-select";

export const FormInput = memo(
  ({
    label,
    placeholder,
    className,
    value,
    onChange,
    type = "text",
    helperText,
  }) => {
    const inputClass =
      "w-full border border-white/10 bg-white/5 text-white px-4 py-3 rounded-xl mt-2 outline-none focus:border-blue-500 transition";

    return (
      <div>
        <label className="text-sm text-slate-300">{label}</label>
        <input
          type={type}
          className={className || inputClass}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
        />
        {helperText && (
          <p className="text-xs text-slate-500 mt-1">{helperText}</p>
        )}
      </div>
    );
  },
);

export const FormTextArea = memo(
  ({ label, placeholder, className, value, onChange, rows, type = "text" }) => {
    const inputClass =
      "w-full border border-white/10 bg-white/5 text-white px-4 py-3 rounded-xl mt-2 outline-none focus:border-blue-500 transition";

    return (
      <div>
        <label className="text-sm text-slate-300">{label}</label>
        <textarea
          className={className || inputClass}
          rows={rows}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
        />
      </div>
    );
  },
);

// export const FormSelect = memo(

//   ({
//     label,
//     className = "",
//     value,
//     onChange,
//     options = [],
//     placeholder = "Select",
//   }) => {
//     return (
//       <div>
//         <label className="mb-1 block text-sm font-medium text-slate-300">
//           {label}
//         </label>

//         <select
//           value={value}
//           onChange={onChange}
//           className={`
//             w-full rounded-lg border border-slate-700
//             bg-slate-800 px-4 py-2.5
//             text-sm text-white
//             outline-none transition
//             focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20
//             ${className}
//           `}
//         >
//           <option value="" className="bg-slate-800 text-white">
//             {placeholder}
//           </option>

//           {options.map((item) => (
//             <option
//               key={item.value}
//               value={item.value}
//               className="bg-slate-800 text-white"
//             >
//               {item.label}
//             </option>
//           ))}
//         </select>
//       </div>
//     );
//   }
// );

export const FormSelect = memo(
  ({
    label,
    value,
    onChange,
    options = [],
    placeholder = "Select",
    className = "",
    isClearable = false,
    isDisabled = false,
  }) => {
    const selectedOption = options.find((item) => item.value === value) || null;

    return (
      <div className={className}>
        <label className="mb-1 block text-sm font-medium text-slate-300">
          {label}
        </label>

        <Select
          options={options}
          value={selectedOption}
          onChange={(selected) =>
            onChange({
              target: {
                value: selected ? selected.value : "",
              },
            })
          }
          placeholder={placeholder}
          isClearable={isClearable}
          isDisabled={isDisabled}
          classNamePrefix="react-select"
          styles={{
            control: (base, state) => ({
              ...base,
              backgroundColor: "#1e293b",
              borderColor: state.isFocused ? "#3b82f6" : "#334155",
              boxShadow: state.isFocused
                ? "0 0 0 2px rgba(59,130,246,.2)"
                : "none",
              minHeight: "42px",
              "&:hover": {
                borderColor: "#3b82f6",
              },
            }),

            menu: (base) => ({
              ...base,
              backgroundColor: "#1e293b",
              border: "1px solid #334155",
              zIndex: 9999,
            }),

            option: (base, state) => ({
              ...base,
              backgroundColor: state.isFocused
                ? "#334155"
                : state.isSelected
                  ? "#2563eb"
                  : "#1e293b",
              color: "#fff",
              cursor: "pointer",
            }),

            singleValue: (base) => ({
              ...base,
              color: "#fff",
            }),

            placeholder: (base) => ({
              ...base,
              color: "#94a3b8",
            }),

            input: (base) => ({
              ...base,
              color: "#fff",
            }),

            menuList: (base) => ({
              ...base,
              padding: 0,
            }),

            indicatorSeparator: () => ({
              display: "none",
            }),

            dropdownIndicator: (base) => ({
              ...base,
              color: "#94a3b8",
              "&:hover": {
                color: "#fff",
              },
            }),

            clearIndicator: (base) => ({
              ...base,
              color: "#94a3b8",
              "&:hover": {
                color: "#fff",
              },
            }),
          }}
        />
      </div>
    );
  },
);
